import Flex from '@components/Flex/Flex';
import Text from '@components/Text/Text';
import { useTheme } from '@mui/material';
import {
  Container,
  StyledCircularProgress,
  StyledTextContainer,
} from './ProgressRing.styles';
import { ProgressRingProps } from './ProgressRing.types';
import GlobalIntlSingleton from '@setup/intl/GlobalIntlSingleton';

const ProgressRing: React.FC<ProgressRingProps> = ({
  size = 200,
  thickness = 2,
  value = 0,
  hideSecondLabel = false,
  maxValue,
  hideLabels = false,
  hidePercentageLabel = false,
  color = 'primary',
  secondLabel = GlobalIntlSingleton.intl.formatMessage({
    id: 'misc.completed',
  }),
  ...restProps
}) => {
  const theme = useTheme();

  const normalise = (value: number): number => {
    if (!maxValue) {
      return value;
    }

    return Number(((value * 100) / maxValue).toFixed(0));
  };

  return (
    <Container color={color}>
      <StyledCircularProgress
        variant='determinate'
        size={size}
        thickness={thickness}
        value={normalise(value)}
        color={color}
        {...restProps}
      />
      {!hideLabels && (
        <StyledTextContainer>
          {!hidePercentageLabel && (
            <Flex justifyContent='center' alignItems='flex-end'>
              <Text
                variant='h1'
                justifyContent='flex-end'
                color={theme.palette.common.white}
              >
                {normalise(value)}
              </Text>
              <Text
                variant='h5'
                position='relative'
                bottom={12}
                color={theme.palette.common.white}
              >
                %
              </Text>
            </Flex>
          )}
          {!hideSecondLabel && (
            <Text
              variant='h6'
              position='relative'
              bottom={hidePercentageLabel ? 0 : 12}
              color={theme.palette.common.white}
            >
              {secondLabel}
            </Text>
          )}
        </StyledTextContainer>
      )}
    </Container>
  );
};

export default ProgressRing;
